import { render, staticRenderFns } from "./SawboRapidFooter.vue?vue&type=template&id=c3a57840&scoped=true&"
import script from "./SawboRapidFooter.vue?vue&type=script&lang=js&"
export * from "./SawboRapidFooter.vue?vue&type=script&lang=js&"
import style0 from "./SawboRapidFooter.vue?vue&type=style&index=0&id=c3a57840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a57840",
  null
  
)

export default component.exports